import { Component, Input } from '@angular/core';

@Component({
  selector: 'app-empty-result',
  templateUrl: './empty-result.component.html',
  styleUrls: ['./empty-result.component.scss'],
  standalone: false,
})
export class EmptyresultComponent {
  @Input() icon: string;

  constructor() {
    // default info
    this.icon = 'jacto-logo';
  }
}
